import React from 'react'
import styled, { DefaultTheme, withTheme } from 'styled-components'
import { Box, Icon, muiBankTheme } from '@ally/metronome-ui'
import { muiChevronDown, muiChevronUp } from '@ally/metronome-icons'
import { useCustomizeDashboard } from '../../customizationContext/CustomizeDashboardContext'
import { getDisplayName } from '../../utils'

export const StyledButton = styled.button(
  ({ theme: { buttons } }) => buttons.link,
)

const TriggerContent: React.FC<{
  triggerIsIcon: boolean
  theme: DefaultTheme
}> = ({ triggerIsIcon, theme }): React.ReactElement => {
  return (
    <>
      {triggerIsIcon ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="baseline"
          justifyContent="space-between"
          mr="4px"
        >
          <Icon
            icon={muiChevronUp}
            size="lg"
            fill={
              muiBankTheme.colors
                .bluesuedeshoes as keyof typeof muiBankTheme.colors
            }
          />
          <Icon
            icon={muiChevronDown}
            size="lg"
            fill={
              theme.colors.bluesuedeshoes as keyof typeof muiBankTheme.colors
            }
          />
        </Box>
      ) : (
        '+ Customize'
      )}
    </>
  )
}

const CustomizeModalTrigger: React.FC<{
  lob?: string
  theme: DefaultTheme
  triggerIsIcon: boolean
}> = ({ lob, theme, triggerIsIcon }): React.ReactElement => {
  const [, dispatch] = useCustomizeDashboard()
  const ariaLabel = triggerIsIcon
    ? `Customize ${getDisplayName(lob)} account order`
    : 'Select to customize your account view'
  return (
    <StyledButton
      data-testid={lob ? `customize-${lob}-trigger` : 'customize-modal-trigger'}
      aria-label={ariaLabel}
      onClick={(): void => {
        dispatch({ type: 'set isCustomizeModalOpen', payload: true })
      }}
      data-allytmln={
        triggerIsIcon
          ? `${lob}CustomizeAccountOrderButton`
          : 'customizeAccountViewButton'
      }
    >
      <TriggerContent theme={theme} triggerIsIcon={triggerIsIcon} />
    </StyledButton>
  )
}

export default withTheme(CustomizeModalTrigger)
